// Module
var code = `<template>
  <div class.bind="cssClass" focus.bind="hasFocus" innerhtml.bind="value | numericFormatter:'fourDec'"></div>
</template>

`;
// Exports
export default code;